import React from 'react';

function ContactCard() {
  return (
    <div style={{ textAlign: 'center', paddingTop: '4rem' }}>
      <p>All inquiries to <strong>skyjungofficial@gmail.com</strong></p>
      <a
        href="mailto:skyjungofficial@gmail.com"
        className="contact-button"
        style={{
          display: 'inline-block',
          marginTop: '1rem',
          padding: '8px 20px',
          fontSize: '0.85rem',
          textDecoration: 'none',
        }}
      >
        Contact
      </a>
    </div>
  );
}

export default ContactCard;
